import downarrow from '../../assets/service/down-arrow.png'
import infogethering from '../../assets/project icons/infogethering.png'
import planning from '../../assets/project icons/planning.png'
import designing from '../../assets/project icons/designing.png'
import frontend from '../../assets/project icons/frontend-coding.png'
import backend from '../../assets/project icons/backend-coding.png'
import testing from '../../assets/project icons/testing.png'
import delpoyment from '../../assets/project icons/server-upload.png'
import support from '../../assets/project icons/support.png'
const howwebuildProject =()=>{
    return(
        <>
            <div className="container-fluid" style={{background:'#F5F5F7'}}>
                <div className="container servicesContent" style={{padding:'50px'}}>
                    <p style={{color:'#0c0c0cff'}}>Project</p>
                    <h2 style={{color:'#3e13c0ff', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>How We Build Your Dream Project ?</h2>                    
                    <div className='mt-4 text-secondary'>
                        <h5 className=''>Requirement Gathering</h5>
                        .<div
                            class="row g-2"
                        >
                            <div class="col-md-2 p-0"><img src={infogethering}/></div>
                            <div class="col-md-9 p-0">
                                <ul className='mb-4'>
                                    <li>Understand the goal of the website (informative, eCommerce, service-based, Android/iOS etc.)</li>
                                    <li>Identify the target audience</li>
                                    <li>Finalize features and functionalities</li>
                                    <li>Choose technology stack: HTML/CSS/JS, PHP, React, Node, etc.</li>
                                </ul>

                            </div>
                            
                        </div>
                        
                        
                        
                        <img src={downarrow} className='mb-4' alt='down arrow'/>
                
                        <h5 className=''>Planning</h5>
                        <div
                            class="row g-2"
                        >
                            <div class="col-md-2 p-0"><img src={planning}/></div>
                            <div class="col-md-9 p-0">
                            <ul className='mb-4'>
                            <li>Define project scope</li>
                            <li>Create sitemap (all pages to be created)</li>
                            <li>Define timeline & milestones</li>
                            <li>Decide on hosting & domain setup</li>
                        </ul> </div>
                        </div>
                            
                                                   
                
                        <img src={downarrow} className='mb-4' alt='down arrow'/>

                        <h5 className='mb-4'>Design (UI/UX)</h5>
                        <div
                            class="row g-2"
                        >
                            <div class="col-md-2 p-0"><img src={designing}/></div>
                            <div class="col-md-9 p-0"><ul className='mb-4'>
                            <li>Create wireframes/mockups (Figma, Adobe XD)</li>
                            <li>Focus on user experience and responsiveness</li>
                            <li>Finalize colors, fonts, layout, icons</li>                            
                        </ul></div>
                           
                        </div>
                        
                        

                        <img src={downarrow} className='mb-4' alt='down arrow'/>

                        <h5 className=''>Frontend Development</h5>
                        <div
                            class="row g-2"
                        >
                            <div class="col-md-2 p-0"><img src={frontend}/></div>
                            <div class="col-md-9 p-0"> <ul className='mb-4'>
                            <li>Convert design into HTML/CSS/JS, React, React Native or Flutter</li>
                            <li>Ensure responsive layout</li>
                            <li>Add animations and effects (if needed)</li>
                            <li>Optimize for performance and SEO</li>                            
                        </ul> </div>
                            
                        </div>
                        
                         

                        <img src={downarrow} className='mb-4' alt='down arrow'/>
 
                        <h5 className=''>Backend Development</h5>
                        <div
                            class="row g-2"
                        >
                            <div class="col-md-2 p-0"><img src={backend}/></div>
                            <div class="col-md-9 p-0">
                                <ul className='mb-4'>
                                    <li>Set up server and database (PHP/MySQL, Node.js/MongoDB, Flutter/Firebase, etc.)</li>
                                    <li>Build admin panel (to manage content)</li>
                                    <li>Develop dynamic features (login, forms, product uploads, etc.)</li>
                                    <li>Integrate APIs if required (payment, maps, etc.)</li>                            
                                </ul>
                            </div>
                            
                        </div>
                        
                      

                        <img src={downarrow} className='mb-4' alt='down arrow'/>

                        <h5 className=''>Testing & QA</h5>
                        <div
                            class="row g-2"
                        >
                            <div class="col-md-2 p-0"><img src={testing}/></div>
                            <div class="col-md-9 p-0">
                                <ul className='mb-4'>
                                    <li>Fix bugs</li>
                                    <li>Load time optimization</li>
                                    <li>Browser compatibility</li>
                                    <li>Broken links or pages</li>
                                    <li>Mobile responsiveness</li>                            
                                </ul>
                            </div>
                            
                        </div>

                        <img src={downarrow} className='mb-4' alt='down arrow'/>

                        <h5 className=''>Deployment</h5>

                        <div
                            class="row g-2"
                        >
                            <div class="col-md-2 p-0"><img src={delpoyment}/></div>
                            <div class="col-md-9 p-0"><ul >
                            <li>Move code to live server</li>
                            <li>Configure domain and SSL</li>
                            <li>Set up email services (e.g., contact forms)</li>
                            <li>Final security and performance check</li>
                                                        
                        </ul></div>
                        </div>   
                        
                        <img src={downarrow} className='mb-4' alt='down arrow'/>

                        <h5 className=''>Support</h5>

                        <div
                            class="row g-2"
                        >
                            <div class="col-md-2 p-0"><img src={support}/></div>
                            <div class="col-md-9 p-0"><ul >
                            <li>24*7 Tech Support</li>
                            <li>6 Months Free Maintenance</li>
                            <li>Chat Support / Mail Support / Call Support</li>                                                        
                        </ul></div>
                        </div>  
                        
                                  
                    </div>                    
                
                        
                </div>
            </div>
        </>
    )
}

export default howwebuildProject